"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var button_style_component_1 = require("./button.style.component");
exports.sizeMixin = styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-width: ", ";\n  height: ", ";\n  font-size: ", ";\n"], ["\n  min-width: ", ";\n  height: ", ";\n  font-size: ", ";\n"])), function (props) { return (props.large ? '272px' : '136px'); }, function (props) { return (props.large ? '48px' : '32px'); }, function (props) { return (props.large ? '16px' : '12px'); });
var baseButtonStyles = styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n  font-style: normal;\n  text-transform: uppercase;\n  ", ";\n  color: ", ";\n  background: ", ";\n  border: 0;\n  transition: all 0.15s ease-in-out;\n  box-sizing: border-box;\n  padding: 0 8px;\n  &:hover {\n    cursor: pointer;\n    background: ", ";\n  }\n  &:focus {\n    outline: none;\n    background: ", ";\n  }\n  &:disabled {\n    cursor: not-allowed;\n    background-color: ", ";\n  }\n\n  svg {\n    margin-right: 4px;\n    stroke: ", ";\n    fill: ", ";\n    height: 14px;\n    width: 14px;\n  }\n"], ["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n  font-style: normal;\n  text-transform: uppercase;\n  ", ";\n  color: ", ";\n  background: ", ";\n  border: 0;\n  transition: all 0.15s ease-in-out;\n  box-sizing: border-box;\n  padding: 0 8px;\n  &:hover {\n    cursor: pointer;\n    background: ", ";\n  }\n  &:focus {\n    outline: none;\n    background: ", ";\n  }\n  &:disabled {\n    cursor: not-allowed;\n    background-color: ", ";\n  }\n\n  svg {\n    margin-right: 4px;\n    stroke: ", ";\n    fill: ", ";\n    height: 14px;\n    width: 14px;\n  }\n"])), exports.sizeMixin, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.primary.text;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.primary.background;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.primary.backgroundHover;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.primary.backgroundFocus;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.primary.disabled;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.primary.text;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.primary.text;
});
exports.Button = function (_a) {
    var icon = _a.icon, onClick = _a.onClick, testID = _a.testID, children = _a.children, className = _a.className, disabled = _a.disabled;
    return (
    // eslint-disable-next-line react/forbid-elements
    react_1.default.createElement("button", { onClick: onClick, className: className, disabled: disabled, "data-test-id": testID },
        icon && react_1.default.createElement(button_style_component_1.ButtonIcon, null, icon),
        " ",
        children));
};
exports.Button.displayName = 'Button';
exports.PrimaryButton = styled_components_1.default(exports.Button)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), baseButtonStyles);
exports.PrimaryButton.displayName = 'PrimaryButton';
exports.SecondaryButton = styled_components_1.default(exports.Button)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  background: none;\n  border: 1px solid ", ";\n  &:hover {\n    border-color: ", ";\n    background: none;\n  }\n  &:focus {\n    border-color: ", ";\n    background: none;\n  }\n"], ["\n  ", ";\n  color: ", ";\n  background: none;\n  border: 1px solid ", ";\n  &:hover {\n    border-color: ", ";\n    background: none;\n  }\n  &:focus {\n    border-color: ", ";\n    background: none;\n  }\n"])), baseButtonStyles, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.secondary.color;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.secondary.color;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.primary.backgroundHover;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.primary.backgroundFocus;
});
exports.SecondaryButton.displayName = 'SecondaryButton';
exports.AlarmButton = styled_components_1.default(exports.Button)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  background: ", ";\n  border: 0;\n  &:hover {\n    background: ", ";\n  }\n  &:focus {\n    background: ", ";\n  }\n"], ["\n  ", ";\n  color: ", ";\n  background: ", ";\n  border: 0;\n  &:hover {\n    background: ", ";\n  }\n  &:focus {\n    background: ", ";\n  }\n"])), baseButtonStyles, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.alarm.text;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.alarm.background;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.alarm.backgroundHover;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.alarm.backgroundFocus;
});
exports.AlarmButton.displayName = 'AlarmButton';
exports.TextButton = styled_components_1.default(exports.Button)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", ";\n  min-width: unset;\n  color: ", "; \n  background: none;\n  padding: 0;\n  border: 0;\n  &:hover {\n    background: none;\n  }\n  &:focus {\n    outline: none;\n    background: none;\n"], ["\n  ", ";\n  min-width: unset;\n  color: ",
    "; \n  background: none;\n  padding: 0;\n  border: 0;\n  &:hover {\n    background: none;\n  }\n  &:focus {\n    outline: none;\n    background: none;\n"])), baseButtonStyles, function (_a) {
    var colours = _a.theme.colours, primaryColor = _a.primaryColor;
    return primaryColor ? colours.button.text.color : colours.button.secondary.color;
});
exports.TextButton.displayName = 'TextButton';
exports.default = exports.PrimaryButton;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
